<template>
  <div class="faq__content">
    <expand-panel
      v-for="(item, i) in faq"
      :key="i"
      :item="item"
      :active="activeQuestion === i"
      @click="(e) => setActiveQuestion(e, i)"
    />
  </div>
</template>

<script>
export default {
  name: "FAQ",

  data() {
    return {
      faq: [
        {
          q: "Is it necessary to exercise every day?",
          a: "You need to keep in mind that the body needs time to recover from intense training, so it is recommended to include rest and recovery periods in the training day schedule. Overexertion can lead to injury and overtraining. Usually 2-3 workouts per week are enough to be in shape.",
        },
        {
          q: "Can I lose weight without working out?",
          a: "Sure thing! Nutrition is the most important element in weight loss. However, if you start exercising, your body will get more toned and defined. The 10-15 min workouts are suitable for beginners and can seamlessly fit into the busiest schedule.",
        },
        {
          q: "How often is it okay to meditate?",
          a: "The frequency of meditation depends on your personal preferences, goals, and abilities. Some people meditate every day in the morning and evening, while others prefer to meditate a few times a week or only as needed. It is important to listen to your sensations and the needs of your body and mind.\n" +
            "If you are a beginning practitioner, it may be helpful to start with short meditation sessions, such as 5-10 minutes a day, and gradually increase the length and frequency of practice as your skills improve.\n" +
            "If you have specific goals for meditation, such as relieving stress, improving concentration or finding inner peace, it is recommended that you practice meditation regularly to achieve your desired results.\n" +
            "If you feel tired or exhausted from meditation, you may want to take a break or reduce your practice time. The main thing is that meditation should be beneficial and enjoyable for you, not a source of additional stress.",
        },
      ],
      activeQuestion: null,
      activeElement: null,
      verticalPadding: 32,
    }
  },

  methods: {
    setActiveQuestion(event, n) {
      if (this.activeQuestion === n) {
        this.activeElement.style.maxHeight = null;
        return this.activeQuestion = null;
      }

      if (this.activeElement) {
        this.activeElement.style.maxHeight = null;
      }

      this.activeQuestion = n;
      const panel = event.target.closest(".faq__question").nextElementSibling;
      this.activeElement = panel;

      if (panel) {
        panel.style.maxHeight = panel.scrollHeight + this.verticalPadding + "px";
      }
    },
  },
}
</script>

<style lang="sass" scoped>
.faq__content
  display: flex
  justify-content: center
  align-items: center
  flex-direction: column
  margin: 0 auto
  gap: 16px
  max-width: 597px
</style>
